import { MuscleCoverageCompactSection } from "./MuscleCoverageCompactSection";
import { usePlanGapsCoverage } from "./planGaps";
import type { ProgressDeps } from "./types";

// The coverage census wired from a host's ProgressDeps: Progress mounts it at
// the top, the Home mounts it as a widget (HR-11). One wiring, two callsites.
export function MuscleCoverageCard({
  deps,
  locale,
}: {
  deps: ProgressDeps;
  locale: string;
}) {
  // `error` and `status` are read, not dropped: a failed read says so (PG-8),
  // and disk numbers the network has not confirmed are not final (PG-15).
  const { coverage, results, catalog, error, status, planToday } = usePlanGapsCoverage(deps);
  // AP-9b: only a host that can open the logger passes the handler, so a
  // coach never sees the link. #540: the bodyweight toggle is the draft's.
  const build = deps.onBuildToday;
  const onBuildToday =
    build && catalog && planToday
      ? () => {
          const { gaps, ...bodyweight } = planToday();
          build(gaps, catalog, bodyweight);
        }
      : undefined;
  return (
    <MuscleCoverageCompactSection
      theme={deps.theme}
      coverage={coverage}
      units={deps.units}
      locale={locale}
      figure={deps.figure}
      isDark={deps.isDark}
      loading={results === null || catalog === null}
      error={error}
      status={status}
      onBuildToday={onBuildToday}
    />
  );
}
